// @flow

import * as React from "react";
import Ui from "ui";
import Flex from "ui/atoms/Flex";
import FlexBox from "ui/atoms/FlexBox";
import TextField from "ui/molecules/TextField";

import { ButtonGroup } from "@/ui/atoms/ButtonGroup";

type Props = {
  phone: ?string,
  willUseEmail: boolean,
  setPhone: (string) => void,
  onChangeEmailToggle: () => void,
  formErrorLabel: { [string]: string },
  formError: { [string]: string },
  validateEmail: (string) => void,
  validatePhone: (string) => void,
  setEmail: (string) => void,
  email: ?string,
};

function SendResourceModalContactField({
  phone,
  willUseEmail,
  setPhone,
  onChangeEmailToggle,
  formErrorLabel,
  formError,
  validateEmail,
  validatePhone,
  setEmail,
  email,
}: Props): React.Node {
  return (
    <FlexBox>
      <Flex>
        <FlexBox>
          <Ui.QuestionTitle>
            {willUseEmail ? "Email" : "Phone"}
          </Ui.QuestionTitle>
        </FlexBox>
        <ButtonGroup.Root className="mb-1.5 -mt-3">
          <ButtonGroup.Item
            isActive={!willUseEmail}
            onClick={() => onChangeEmailToggle(false)}
          >
            Phone
          </ButtonGroup.Item>
          <ButtonGroup.Item
            isActive={willUseEmail}
            onClick={() => onChangeEmailToggle(true)}
          >
            Email
          </ButtonGroup.Item>
        </ButtonGroup.Root>
      </Flex>
      {willUseEmail ? (
        <TextField
          errorLabel={formErrorLabel?.email}
          hasError={Boolean(formError?.email)}
          name="person_email"
          onBlur={validateEmail}
          onChange={setEmail}
          placeholder="Email"
          type="email"
          value={email}
        />
      ) : (
        <Ui.SingleLinePhone
          errorLabel={formErrorLabel?.phone}
          hasError={formError?.phone}
          name="person_phone"
          onBlur={validatePhone}
          onChange={setPhone}
          placeholder="Phone Number"
          type="phone"
          value={phone}
        />
      )}
    </FlexBox>
  );
}

export default SendResourceModalContactField;
